/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";

import BreadCrumbs from "./BreadCrumbs";
import {
    resetBreadCrumpData,
    popBreadCrumpData,
    popBreadCrumpOnPageClose,
    findPrevPathFromBreadCrumpData,
    updateBreadCrumpData,
    showAlert as showAlertUtil,
    getDefaultDashboardLocation,
    isAssetDefaultDashboard
} from "../../../config/utils";
import { getAssetDashboardBreadCrumb } from "./DashboardSwitcher";
import history from "../../../config/history";
import Calculator from "./calculator/index";
import userAction from "../../user/actions";
import Portal from "./Portal";
import ForgotModal from "./forgotPasswordModal";
import ShowHelperModal from "../../helper/components/ShowHelperModal";
import { APP_MODE } from "../../../config/constants";
import trainingAppLogo from "../../../assets/img/logo-trainer.svg";
import { unSubscribeDevice } from "../../../config/firebase";
import notificationActions from "../../notification/actions";
import closeIcon from "../../../assets/img/close-icn.svg";
import "../../../assets/css/notification.css";
import { ProfilePopup } from "../../dashboard/components/ProfilePopup";
import { DefaultProjectModal } from "../../dashboard/components/DefaultProjectPopup";
import ReportsModal from "../../landingPage/components/ReportsModal";
import HelpIcon from "../../../assets/img/help-white.svg";
import { getCapitalRequestLabel, pluralizeLabel } from "../../../utils/capitalRequestLabel";
import { setPendingAction, triggerUnsavedChangesPrompt } from "../actions";
import { LanguageSettingsModal } from "../../dashboard/components/LanguageSettingsModal";
import { apm } from "../../../apm";
import { navigateWithPrompts } from "../../../utils/navigationHelpers";
import { QuickLinks } from "../../dashboard/components/QuickLinks";
import { getUserProfileImageUrl } from "../../../utils/userProfileImageUrl";

class TopBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showSettingsDropDown: false,
            showCalculatorDropDown: false,
            showNav: true,
            user: "",
            image: "",
            showResetPasswordModal: false,
            showHelperModal: false,
            selectedHelperItem: {},
            showNotificationDropDown: false,
            languageAndCurrencyModal: false,
            errorMessage: ""
        };
        this.refreshInterval = null;
    }

    componentDidMount = async () => {
        let user = localStorage.getItem("user");
        this.setState({ user });
        this.fetchProfileImage();
        window.addEventListener("click", this.handleClickOutside);
        this.props.getUnreadNotifications();
        this.openFullscreenOnCharts();
        this.refreshInterval = setInterval(this.fetchProfileImage, 2 * 60 * 60 * 1000);
    };

    componentDidUpdate = async prevProps => {
        const {
            match: {
                params: { section, tab }
            }
        } = this.props;
        if (prevProps.match.params.tab !== tab || prevProps.match.params.section !== section) {
            this.openFullscreenOnCharts();
        }
    };

    componentWillUnmount() {
        window.removeEventListener("click", this.handleClickOutside);
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    }

    handleClickOutside = e => {
        let profileButton = document.getElementById("profileButton");
        if (profileButton && !profileButton.contains(e.target)) {
            this.setState({
                showSettingsDropDown: false
            });
        }
    };

    openFullscreenOnCharts = () => {
        const {
            match: {
                params: { tab }
            }
        } = this.props;
        let element = document.getElementsByTagName("BODY")[0];
        element.requestFullScreen =
            element.requestFullScreen ||
            element.webkitRequestFullScreen ||
            element.mozRequestFullScreen ||
            function () {
                return false;
            };
        document.cancelFullScreen =
            document.cancelFullScreen ||
            document.webkitCancelFullScreen ||
            document.mozCancelFullScreen ||
            function () {
                return false;
            };
        if (tab === "dashboard") {
            element.requestFullScreen();
        } else {
            document.cancelFullScreen();
        }
    };

    renderPasswordModal = () => {
        const { showResetPasswordModal, errorMessage } = this.state;
        if (!showResetPasswordModal) return null;

        return (
            <Portal
                body={<ForgotModal onCancel={this.onCancel} resetPasswordProfile={this.resetPasswordProfile} errorMessage={errorMessage} />}
                onCancel={this.onCancel}
            />
        );
    };

    resetPasswordProfile = async param => {
        let userId = localStorage.getItem("userId");
        await this.props.resetPasswordProfile(userId, param);
        const {
            history,
            loginReducer: { resetPassword }
        } = this.props;

        if (resetPassword && resetPassword.success) {
            this.setState(
                {
                    errorMessage: "",
                    alertMessage: resetPassword.message,
                    subimitDisabled: true,
                    showResetPasswordModal: false
                },
                () => this.showAlert()
            );
        } else {
            this.setState({
                errorMessage: resetPassword?.message || "Error while resetting password"
            });
        }
    };

    showAlert = () => showAlertUtil(this.state.alertMessage);

    onCancel = () => {
        this.setState({
            showResetPasswordModal: false
        });
    };

    toggleSettingsDropDown = async () => {
        const { showSettingsDropDown } = this.state;
        this.setState({
            showSettingsDropDown: !showSettingsDropDown
        });
    };

    toggleCalculatorDropDown = async () => {
        const { showCalculatorDropDown } = this.state;
        this.setState({
            showCalculatorDropDown: !showCalculatorDropDown
        });
    };

    logoutUserConfirm = async () => {
        let userId = localStorage.getItem("userId");
        await unSubscribeDevice(userId);
        await this.props.logoutUser();
        if (apm) apm.setUserContext({ id: null, username: null, email: null });

        localStorage.clear();
        sessionStorage.clear();
        history.push("/");
    };

    closeNav = () => {
        var element = document.getElementById("sidebar");
        var element1 = document.getElementById("main");
        this.props.handleShowNa();
        element.style.width = "30px";
        element1.style.marginLeft = "30px";
        element.classList.add("expandnavbar");
        element1.classList.add("expandnavbarr");
        element1.classList.remove("margin-nav");
    };

    showNav = () => {
        var element = document.getElementById("sidebar");
        var element1 = document.getElementById("main");
        this.props.handleShowNa();
        element.style.width = "300px";
        element1.style.marginLeft = "300px";
        element.classList.remove("expandnavbar");
        element1.classList.remove("expandnavbarr");
        element1.classList.add("margin-nav");
    };

    toggleFullscreen = event => {
        var element = document.getElementsByTagName("BODY")[0];
        var isFullscreen = document.webkitIsFullScreen || document.mozFullScreen || false;
        if (event instanceof HTMLElement) {
            element = event;
        }

        element.requestFullScreen =
            element.requestFullScreen ||
            element.webkitRequestFullScreen ||
            element.mozRequestFullScreen ||
            function () {
                return false;
            };
        document.cancelFullScreen =
            document.cancelFullScreen ||
            document.webkitCancelFullScreen ||
            document.mozCancelFullScreen ||
            function () {
                return false;
            };

        if (isFullscreen) {
            document.cancelFullScreen();
        } else {
            element.requestFullScreen();
        }
        isFullscreen ? document.cancelFullScreen() : element.requestFullScreen();
    };

    viewUser = () => {
        this.toggleSettingsDropDown();
        let userId = localStorage.getItem("userId");
        const { history } = this.props;
        const {
            location: { search }
        } = this.props;
        this.setState({
            selectedUser: userId,
            infoTabsData: [
                {
                    key: "basicdetails",
                    name: "Basic Details",
                    path: `/user/userinfo/${userId}/basicdetails`
                },
                {
                    key: "buildings",
                    name: "Buildings",
                    path: `/user/userinfo/${userId}/buildings${search}`
                },
                {
                    key: "projects",
                    name: "FCA Projects",
                    path: `/user/userinfo/${userId}/projects${search}`
                }
            ]
        });
        let tabKeyList = ["basicdetails", "buildings", "projects"];
        let tab = "basicdetails";
        resetBreadCrumpData({
            key: "main",
            name: "User",
            path: `/user/userinfo/${userId}/${tab}`
        });
        history.push(`/user/userinfo/${userId}/${tab}`);

        // history.push("/");
    };

    showHelperModal = async (item, subItem) => {
        await this.setState({
            showHelperModal: true,
            selectedHelperItem: {
                item,
                subItem
            }
        });
    };

    renderUploadHelperModal = () => {
        const { showHelperModal, selectedHelperItem } = this.state;
        if (!showHelperModal) return null;
        return (
            <Portal
                body={<ReportsModal doc_id={"tutorials"} doc_name={""} onCancel={() => this.setState({ showHelperModal: false })} />}
                onCancel={() => this.setState({ showHelperModal: false })}
            />
        );
    };

    findEntity = entity => {
        let retVal = entity;
        if (entity[entity.length - 1] === "y") {
            retVal = entity.slice(0, -1) + "ies";
        } else if (entity[entity.length - 1] === "s") {
            retVal = entity.slice(0, -1) + "s";
        } else {
            retVal = entity + "s";
        }
        return retVal.toLowerCase();
    };

    findUrlFromProps = () => {
        const {
            location: { pathname = null }
        } = this.props;
        let returnVal = null;
        if (pathname) {
            returnVal = pathname.split("/");
            returnVal = returnVal && returnVal.length ? this.findEntity(returnVal[1]) : null;
            if (returnVal === "reports") {
                returnVal = "fca_reports";
            } else if (returnVal === "projects") {
                returnVal = "fca_projects";
            } else if (returnVal === "efcis") {
                returnVal = "efci";
            }
            return returnVal;
        }
        return null;
    };

    Goback = () => {
        const { isFormDirty } = this.props;
        const action = () => {
            let currentBreadCrumpData = JSON.parse(sessionStorage.getItem("bc-data"));
            let keys = currentBreadCrumpData.map(item => item.name);
            const lastBcName = currentBreadCrumpData[keys.length - 1].name;
            const lastBcKey = currentBreadCrumpData[keys.length - 1].key;
            const firstBcName = currentBreadCrumpData?.[0]?.name;
            if (lastBcName === "Basic Details" || (lastBcName === "Main Details" && firstBcName !== "Notifications")) {
                popBreadCrumpOnPageClose();
            } else if (lastBcKey === "assignedInfo") {
                currentBreadCrumpData.length -= 2; // removing last items form current data
                let newBreadCrumpData = currentBreadCrumpData;
                sessionStorage.setItem("bc-data", JSON.stringify(newBreadCrumpData));
            } else if ((lastBcName === "Charts & Graphs" || lastBcName === "EFCI Sandbox") && firstBcName === "EFCI") {
                updateBreadCrumpData(0);
            } else {
                popBreadCrumpData();
            }
            history.push(findPrevPathFromBreadCrumpData());
        };
        navigateWithPrompts({
            isFormDirty,
            navigateAction: action
        });
    };

    toggleNotificationsDropDown = async () => {
        const { showNotificationDropDown } = this.state;
        this.setState(
            {
                showNotificationDropDown: !showNotificationDropDown
            },
            async () => {
                if (this.state.showNotificationDropDown) {
                    await this.props.getUnreadNotifications();
                    this.updateNotifications(null, true, false, true, "seen_at");
                }
            }
        );
    };

    showAllNotifications = async () => {
        await this.setState({
            showNotificationDropDown: false
        });
        resetBreadCrumpData({
            key: "main",
            name: "Notifications",
            path: "/settings/notifications"
        });
        history.push("/settings/notifications");
    };

    updateNotifications = async (id, is_seen = false, is_read = false, isBulkUpdate = false, key = "") => {
        let notificationIds = [];
        if (isBulkUpdate) {
            let currentNotifications = this.props.notificationReducer.getUnreadNotificationsResponse?.data || [];
            currentNotifications.map(notification => {
                if (!notification[key]) {
                    notificationIds.push(notification.id);
                }
            });
        }
        if (notificationIds.length) {
            let updateParams = {
                notification_id: isBulkUpdate ? [...notificationIds] : [id],
                is_read,
                is_seen
            };
            await this.props.updateNotifications(updateParams);
            this.props.getUnreadNotifications({ force: true });
            if (is_read && isBulkUpdate) {
                this.setState({ showNotificationDropDown: false });
                resetBreadCrumpData({
                    key: "main",
                    name: "Notifications",
                    path: "/settings/notifications"
                });
                history.push("/settings/notifications");
            }
        }
    };
    toggleDefaultProjectModal = () => {
        this.setState({ showSettingsDropDown: false, showDefaultProjectModal: !this.state.showDefaultProjectModal });
    };

    renderDefaultProjectModal = () => {
        const { showDefaultProjectModal } = this.state;
        if (!showDefaultProjectModal) return null;

        return <Portal body={<DefaultProjectModal onCancel={this.toggleDefaultProjectModal} />} onCancel={this.toggleDefaultProjectModal} />;
    };

    toggleLanguageAndCurrencyModal = () => {
        this.setState({ showSettingsDropDown: false, languageAndCurrencyModal: !this.state.languageAndCurrencyModal });
    };

    renderLanguageAndCurrencyModal = () => {
        const { languageAndCurrencyModal } = this.state;
        if (!languageAndCurrencyModal) return null;

        return (
            <Portal body={<LanguageSettingsModal onCancel={this.toggleLanguageAndCurrencyModal} />} onCancel={this.toggleLanguageAndCurrencyModal} />
        );
    };

    fetchProfileImage = async () => {
        try {
            let image = localStorage.getItem("image");
            if (image && image !== "null") {
                const url = await getUserProfileImageUrl(image);
                if (url) {
                    this.setState({ image: url });
                }
            }
        } catch (error) {
            console.error("Error fetching profile image URL:", error);
        }
    };

    render() {
        const { showSettingsDropDown, showCalculatorDropDown, user, image, showNotificationDropDown } = this.state;
        const { showNav, isCrHeader } = this.props;
        let currentBreadCrumpData = JSON.parse(sessionStorage.getItem("bc-data"));
        let notificationList = this.props.notificationReducer.getUnreadNotificationsResponse?.data || [];
        let notificationCount = this.props.notificationReducer.getUnreadNotificationsResponse?.count || 0;
        let lastItem = currentBreadCrumpData && currentBreadCrumpData[currentBreadCrumpData?.length - 1];

        let entity = this.findUrlFromProps();
        const windowWidth = window.innerWidth;
        const isIpad = windowWidth < 991;

        const default_project_id = localStorage.getItem("default_project");
        return (
            <>
                <div className="col-md-12 navbarOtr">
                    {this.renderPasswordModal()}
                    {this.renderDefaultProjectModal()}
                    {this.renderLanguageAndCurrencyModal()}
                    <nav className="navbar navbar-expand-lg col-md-12">
                        <a
                            className="logo-small navbar-brand cursor-pointer"
                            onClick={() => {
                                if (isCrHeader) {
                                    const path = `/project/projectinfo/${default_project_id}/cr-recommendations`;
                                    resetBreadCrumpData({
                                        key: "info",
                                        name: pluralizeLabel(
                                            getCapitalRequestLabel(this.props.projectReducer?.getProjectByIdResponse?.miscellaneous)
                                        ),
                                        path: path
                                    });
                                    history.push(path);
                                } else {
                                    resetBreadCrumpData({
                                        key: "main",
                                        name: "Dashboard",
                                        path: "/dashboard"
                                    });
                                    history.push("/dashboard");
                                    this.showNav();
                                }
                            }}
                        >
                            <img src={APP_MODE === "training" ? trainingAppLogo : "/img/fca-logo.svg"} alt="" />
                        </a>
                        {showNav || isIpad ? (
                            <div className="navmenuIcon" onClick={() => (showNav ? this.closeNav() : this.showNav())}>
                                <svg
                                    version="1.1"
                                    id="Layer_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    x="0px"
                                    y="0px"
                                    width="120px"
                                    height="120px"
                                    viewBox="0 0 120 120"
                                    enableBackground="new 0 0 120 120"
                                    xmlSpace="preserve"
                                >
                                    <circle fill="#B7C6D5" cx="60" cy="60" r="60" />
                                    <g>
                                        <g>
                                            <path
                                                d="M75,88.291c0.944-0.944,0.944-2.472,0-3.417L50.125,60L75,35.126c0.944-0.945,0.944-2.472,0-3.417
c-0.945-0.945-2.473-0.945-3.418,0L45,58.291c-0.472,0.472-0.708,1.09-0.708,1.709c0,0.619,0.236,1.237,0.708,1.708l26.582,26.583
C72.527,89.236,74.055,89.236,75,88.291z"
                                            />
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        ) : null}
                        {currentBreadCrumpData &&
                        currentBreadCrumpData?.length > 1 &&
                        !(currentBreadCrumpData?.length === 2 && currentBreadCrumpData?.[0]?.path === currentBreadCrumpData?.[1]?.path) &&
                        !(currentBreadCrumpData?.length === 2 && currentBreadCrumpData?.[0]?.name === "Email") &&
                        !(currentBreadCrumpData?.length === 2 && currentBreadCrumpData?.[0]?.disabled) &&
                        !(currentBreadCrumpData?.length === 3 && currentBreadCrumpData?.[0]?.disabled && currentBreadCrumpData?.[2]?.disabled) ? (
                            <>
                                <ReactTooltip id="topbar" />
                                <button
                                    data-delay-show="1000"
                                    data-tip={`Go Back To Previous View`}
                                    data-effect="solid"
                                    data-place="bottom"
                                    data-background-color="#007bff"
                                    data-for="topbar"
                                    className="back-blue-common-butn"
                                    onClick={this.Goback}
                                >
                                    <i className="fas fa-caret-left"></i>Back
                                </button>
                            </>
                        ) : lastItem?.key === "main" && lastItem?.name === "User" ? (
                            <>
                                <ReactTooltip id="topbar" />
                                <button
                                    data-delay-show="1000"
                                    data-tip={`Go Back To Dashboard`}
                                    data-effect="solid"
                                    data-place="bottom"
                                    data-background-color="#007bff"
                                    data-for="topbar"
                                    className="back-blue-common-butn"
                                    onClick={() => {
                                        const action = () => {
                                            resetBreadCrumpData(
                                                isAssetDefaultDashboard()
                                                    ? getAssetDashboardBreadCrumb()
                                                    : { key: "main", name: "Dashboard", path: "/dashboard" }
                                            );
                                            history.push(getDefaultDashboardLocation());
                                        };

                                        navigateWithPrompts({
                                            isFormDirty: this.props.isFormDirty,
                                            navigateAction: action
                                        });
                                    }}
                                >
                                    <i className="fas fa-caret-left"></i>Back To Dashboard
                                </button>
                            </>
                        ) : null}
                        <div className="breadcrumb-wrapper pl-0">
                            <BreadCrumbs />
                        </div>
                        <div className="navbar-collapse" id="navbarSupportedContent">
                            <ReactTooltip id="topbar" />
                            <ReactTooltip
                                id="dashboard-icons-right"
                                place="bottom"
                                effect="solid"
                                backgroundColor="#007bff"
                                className="rc-tooltip-custom-class"
                                multiline={true}
                            />
                            <ul className="navbar-nav ml-auto">
                                <QuickLinks
                                    projectId={
                                        this.props.dashboardReducer?.getDashboard?.side_panel?.project_ids?.length === 1
                                            ? this.props.dashboardReducer?.getDashboard?.side_panel?.project_ids[0]
                                            : null
                                    }
                                    projectName={this.props.dashboardReducer?.getDashboard?.side_panel?.project_name}
                                    clientId={this.props.dashboardReducer?.getDashboard?.side_panel?.clients?.[0]?.id}
                                    clientName={this.props.dashboardReducer?.getDashboard?.side_panel?.clients?.[0]?.name}
                                    ReactTooltip={ReactTooltip}
                                />
                                <li className="nav-item dropdown profileImg d-flex align-items-center calc" id="calc">
                                    <a
                                        className="nav-link calcicons view-inner help-icon"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        data-tip={`Help`}
                                        data-effect="solid"
                                        data-place="bottom"
                                        data-background-color="#007bff"
                                        data-for="topbar"
                                        onClick={() => {
                                            this.showHelperModal("menu", entity);
                                        }}
                                    >
                                        <img src={HelpIcon} alt="" className="fil-ico" />
                                    </a>
                                    {/* {showCalculatorDropDown ? (
                                        <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                            <Calculator />
                                        </div>
                                    ) : null} */}
                                </li>
                                {this.renderUploadHelperModal()}
                                <li className="d-flex align-items-center">
                                    <a
                                        className="nav-link calcicons"
                                        onClick={e => this.toggleFullscreen(e)}
                                        data-tip={`Full screen`}
                                        data-effect="solid"
                                        data-place="bottom"
                                        data-background-color="#007bff"
                                        data-for="topbar"
                                    >
                                        <img src="/img/restore.svg" alt="" className="set-icon-width" />
                                    </a>
                                </li>
                                <li className="d-flex align-items-center imgNoti dropdown notificationShow" id="notificationBellButton">
                                    <a className="nav-link notifctnBell" onClick={() => this.toggleNotificationsDropDown()}>
                                        <img src="/img/bell.png" alt="" />
                                        <span className="notifyTxt pl-1">
                                            {notificationCount > 10 ? `10+` : notificationCount}
                                        </span>
                                    </a>
                                    {showNotificationDropDown ? (
                                        <div className="dropdown-menu notification">
                                            <div className="head">
                                                <h3>Notification</h3>
                                                <button className="btn btn-see" onClick={() => this.showAllNotifications()}>
                                                    See all
                                                </button>
                                            </div>
                                            <div className="cnt-sec">
                                                {notificationList?.length ? (
                                                    notificationList.map((notification, i) => {
                                                        return (
                                                            <div
                                                                className="itm notification-item-cont"
                                                                onClick={e => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    this.updateNotifications(null, true, true, true, "read_at");
                                                                }}
                                                            >
                                                                <div className="icon unred">
                                                                    <img src="/img/notification-icn.svg" />
                                                                </div>
                                                                <div className="cnt-area">
                                                                    <h3>{notification.data?.title}</h3>
                                                                    <p>{notification.data?.body}</p>
                                                                    {/* <span>2 min ago</span> */}
                                                                </div>
                                                                <div
                                                                    className="close-notify"
                                                                    onClick={e => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        this.updateNotifications(notification.id, true, true);
                                                                    }}
                                                                >
                                                                    <img src={closeIcon} />
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                ) : (
                                                    <div className="itm">
                                                        {/* <div className="icon unred">
                                                            <img src="/img/notification-icn.svg" />
                                                        </div> */}
                                                        <div className="cnt-area">
                                                            <h3>No New Notifications!</h3>
                                                        </div>
                                                    </div>
                                                )}

                                                {/* <div className="itm">
                                                    <div className="icon">
                                                        <img src="/img/notification-red.svg" />
                                                    </div>
                                                    <div className="cnt-area">
                                                        <h3>American Health FCA</h3>
                                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                                        <span>2 min ago</span>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                    ) : null}
                                </li>

                                <li className="nav-item dropdown profileImg ml-3" id="profileButton">
                                    <div className="profile-dropdown-anchor">
                                        <a
                                            className="nav-link dropdown-toggle d-flex flex-row align-items-center"
                                            onClick={() => this.toggleSettingsDropDown()}
                                        >
                                            <div className="profileImgSec">
                                                <img src={image || "/img/user-icon.png"} onError={() => this.setState({ image: "" })} alt="" />
                                            </div>
                                            <span className="profName notranslate">{user} </span>
                                        </a>
                                        {showSettingsDropDown && (
                                            <ProfilePopup
                                                viewUser={this.viewUser}
                                                handleResetPassword={() => {
                                                    this.setState({
                                                        showResetPasswordModal: true
                                                    });
                                                    this.toggleSettingsDropDown();
                                                }}
                                                handleLogout={this.logoutUserConfirm}
                                                toggleDefaultProjectModal={this.toggleDefaultProjectModal}
                                                hasDefaultProjectMenu={this.props.hasDefaultProjectMenu}
                                                userImage={image}
                                                hasLanguageMenu={true}
                                                toggleLanguageAndCurrencyModal={this.toggleLanguageAndCurrencyModal}
                                                hasScreenCapture={true}
                                                captureScreenshot={() => {
                                                    this.setState({
                                                        showSettingsDropDown: false
                                                    });
                                                    this.props.captureScreenshot();
                                                }}
                                            />
                                        )}
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    const {
        loginReducer,
        notificationReducer,
        dashboardReducer,
        commonReducer: { isFormDirty },
        projectReducer
    } = state;
    return {
        loginReducer,
        notificationReducer,
        dashboardReducer,
        isFormDirty,
        projectReducer
    };
};

const mapDispatchToProps = {
    ...userAction,
    ...notificationActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TopBar));
